
export const prismicIDPattern = /^[a-zA-Z0-9-_]{16}$/
export const slugPattern = /^[a-zA-Z0-9-]+(?:-[a-zA-Z0-9]+)*$/